import {
  Flex,
  Divider,
  useColorModeValue,
  Box,
  Button,
} from '@chakra-ui/react';
import React, { useContext } from 'react';
import { useUserStore } from 'store/user';

import config from 'configs/app';
import { GlobalContext } from 'lib/contexts/globalContext';
import IconSvg from 'ui/shared/IconSvg';

import DeFiDropdown from './DeFiDropdown';
import NetworkMenu from './NetworkMenu';
import Settings from './settings/Settings';
import TopBarStats from './TopBarStats';

const TopBar = () => {
  const bgColor = useColorModeValue('gray.50', 'whiteAlpha.100');
  const globalContext = useContext(GlobalContext);
  const { userRole } = useUserStore();

  return (
    <Flex
      py={ 2 }
      px={{ base: 3, lg: 6 }}
      bgColor={ bgColor }
      justifyContent="space-between"
      alignItems="center"
    >
      { userRole === 'USER' ? <div/> : <TopBarStats/> }
      <Flex alignItems="center">
        { config.features.deFiDropdown.isEnabled && (
          <>
            <DeFiDropdown/>
            <Divider
              mr={ 3 }
              ml={{ base: 2, sm: 3 }}
              height={ 4 }
              orientation="vertical"
            />
          </>
        ) }
        <Settings/>
        { config.UI.navigation.layout === 'horizontal' &&
          Boolean(config.UI.navigation.featuredNetworks) && (
          <Box display={{ base: 'none', lg: 'flex' }}>
            <Divider mx={ 3 } height={ 4 } orientation="vertical"/>
            <NetworkMenu/>
          </Box>
        ) }
        <Button
          colorScheme="blue"
          size="sm"
          marginLeft={ 3 }
          onClick={ globalContext?.handleLogout }
          padding={ 4 }
          paddingY={ 5 }
        >
          <IconSvg name="logout" boxSize={ 5 } fill="#fff" mr="2px"/> Sign out
        </Button>
      </Flex>
    </Flex>
  );
};

export default React.memo(TopBar);
